module.exports = __webpack_public_path__ + "img/report.fba48a33.svg";